import { c as _c } from "react/compiler-runtime";
import { useProfile } from "../../../global-account/react/index.js";
import { ecosystemWalletId } from "../../../shared/constants/index.js";
import { debugB3React } from "../../../shared/utils/debug.js";
import { useEffect, useMemo, useState } from "react";
import { getLastAuthProvider, useActiveWallet, useConnectedWallets, useWalletImage } from "thirdweb/react";
import { socialIcons } from "thirdweb/wallets/in-app";
import { useB3Account } from "../components/B3Provider/useB3Account.js";
const debug = debugB3React("useAccountWallet");
function useLastAuthProvider() {
  const $ = _c(2);
  const [lastAuthProvider, setLastAuthProvider] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const fn = async () => {
        const provider = await getLastAuthProvider();
        setLastAuthProvider(provider);
      };
      fn();
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return lastAuthProvider;
}
export function useAccountWallet() {
  const $ = _c(23);
  const account = useB3Account();
  const activeWallet = useActiveWallet();
  const connectedWallets = useConnectedWallets();
  let connectedEOAWallet;
  let connectedSmartWallet;
  let isActiveEOAWallet;
  let isActiveSmartWallet;
  if ($[0] !== activeWallet || $[1] !== connectedWallets) {
    connectedSmartWallet = connectedWallets.find(_temp);
    connectedEOAWallet = connectedWallets.find(_temp2);
    isActiveSmartWallet = activeWallet?.id === connectedSmartWallet?.id;
    isActiveEOAWallet = activeWallet?.id === connectedEOAWallet?.id;
    debug("activeWallet", activeWallet);
    debug("connectedWallets", connectedWallets);
    debug("connectedSmartWallet", connectedSmartWallet);
    debug("connectedEOAWallet", connectedEOAWallet);
    $[0] = activeWallet;
    $[1] = connectedWallets;
    $[2] = connectedEOAWallet;
    $[3] = connectedSmartWallet;
    $[4] = isActiveEOAWallet;
    $[5] = isActiveSmartWallet;
  } else {
    connectedEOAWallet = $[2];
    connectedSmartWallet = $[3];
    isActiveEOAWallet = $[4];
    isActiveSmartWallet = $[5];
  }
  debug("isActiveSmartWallet", isActiveSmartWallet);
  debug("isActiveEOAWallet", isActiveEOAWallet);
  const lastAuthProvider = useLastAuthProvider();
  const smartWalletIcon = lastAuthProvider && !connectedEOAWallet ? socialIcons[lastAuthProvider] : "https://gradvatar.com/0x0000000000000000000000000000000000000000";
  const t0 = account?.address;
  let t1;
  if ($[6] !== t0) {
    t1 = {
      address: t0
    };
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const {
    data: profileData
  } = useProfile(t1);
  let t2;
  if ($[8] !== profileData?.displayName) {
    t2 = profileData?.displayName?.replace(/\.b3\.fun/g, "");
    $[8] = profileData?.displayName;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const ensName = t2;
  let t3;
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      icon: ""
    };
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== account || $[12] !== ensName) {
    t5 = {
      ...account,
      ensName,
      meta: t4
    };
    $[11] = account;
    $[12] = ensName;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = account?.address;
  let t7;
  if ($[14] !== connectedEOAWallet || $[15] !== connectedSmartWallet || $[16] !== ensName || $[17] !== isActiveEOAWallet || $[18] !== isActiveSmartWallet || $[19] !== smartWalletIcon || $[20] !== t5 || $[21] !== t6) {
    t7 = {
      wallet: t5,
      address: t6,
      ensName,
      connectedSmartWallet,
      connectedEOAWallet,
      isActiveSmartWallet,
      isActiveEOAWallet,
      smartWalletIcon,
      eoaWalletIcon: ""
    };
    $[14] = connectedEOAWallet;
    $[15] = connectedSmartWallet;
    $[16] = ensName;
    $[17] = isActiveEOAWallet;
    $[18] = isActiveSmartWallet;
    $[19] = smartWalletIcon;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  t3 = t7;
  const res = t3;
  return res;
}
function _temp2(wallet_0) {
  return wallet_0.id !== ecosystemWalletId;
}
function _temp(wallet) {
  return wallet.id === ecosystemWalletId;
}
export function useAccountWalletImage() {
  const $ = _c(4);
  const account = useB3Account();
  const activeWallet = useActiveWallet();
  const connectedWallets = useConnectedWallets();
  const connectedSmartWallet = connectedWallets.find(_temp3);
  let t0;
  if ($[0] !== connectedWallets) {
    t0 = connectedWallets.find(_temp4);
    $[0] = connectedWallets;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const connectedEOAWallet = t0;
  const isActiveSmartWallet = activeWallet?.id === connectedSmartWallet?.id;
  const {
    data: walletImage
  } = useWalletImage(connectedEOAWallet?.id);
  const lastAuthProvider = useLastAuthProvider();
  const smartWalletIcon = lastAuthProvider && !connectedEOAWallet ? socialIcons[lastAuthProvider] : "https://gradvatar.com/0x0000000000000000000000000000000000000000";
  const t1 = account?.address;
  let t2;
  if ($[2] !== t1) {
    t2 = {
      address: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: profileData
  } = useProfile(t2);
  const avatarUrl = profileData?.avatar;
  return avatarUrl || (isActiveSmartWallet ? smartWalletIcon : walletImage) || "";
}
function _temp4(wallet_0) {
  return wallet_0.id !== ecosystemWalletId;
}
function _temp3(wallet) {
  return wallet.id === ecosystemWalletId;
}